// src/pages/Verified.js
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

export default function Verified() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email"); // Firebase will append this
  console.log("Email is: ", email);
  

  useEffect(() => {
    if (email) {
      const checkVerification = async () => {
        try {
          // Ask backend to confirm verification
          const res = await axios.get(
            "https://kast-server-713b1c89d478.herokuapp.com/api/auth/verify-login",
            { params: { email } }
          );

          console.log("Response: ", res);
          

          if (res.data.success) {
            // Save token and redirect (replace with your logic)
            localStorage.setItem("token", res.data.token);
            navigate("/home"); // 👈 Your post-login route
          } else {
            navigate("/login?error=not_verified");
          }
        } catch (err) {
          navigate("/login?error=verification_failed");
        }
      };

      checkVerification();
    } else {
      //navigate("/");
    }
  }, [email, navigate]);

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h2>Verifying your email...</h2>
      <p>You will be logged in automatically.</p>
    </div>
  );
}